import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

function mapStateToProps(state, hocProps) {
    const id = _.get(hocProps, 'mainId', null)

    return {
        toggledDetails: state.getIn([
            'ui',
            'workspace',
            'report',
            id,
            'blocks',
            'syntheticIndicators',
            'customData',
            'toggledDetails',
        ]),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps, null)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
